import React, { useEffect, useState } from 'react'

export function getMaxLogoWidthPercent(naturalWidth, naturalHeight, containerWidth, containerMaxHeight) {
  if (!naturalWidth || !naturalHeight || !containerWidth || !containerMaxHeight) return 100

  const maxByHeight = (containerMaxHeight * naturalWidth) / (containerWidth * naturalHeight) * 100
  return Math.min(100, Math.max(10, Math.floor(maxByHeight)))
}

function getLogoContainerLimits() {
  const logoArea = document.querySelector('.image-preview-logo')
  const editable = document.querySelector('.image-preview-editable')

  return {
    containerWidth: logoArea?.offsetWidth || 336,
    containerMaxHeight: (editable?.clientHeight || 250) - 6
  }
}

const LogoSizeSlider = ({ id, imageSrc, value, onChange }) => {
  const [max, setMax] = useState(100)
  const numericValue = Number(value)

  useEffect(() => {
    if (!imageSrc) {
      setMax(100)
      return
    }

    const img = new Image()
    img.onload = () => {
      const { containerWidth, containerMaxHeight } = getLogoContainerLimits()
      const calculatedMax = getMaxLogoWidthPercent(
        img.naturalWidth,
        img.naturalHeight,
        containerWidth,
        containerMaxHeight
      )
      setMax(calculatedMax)
    }
    img.onerror = () => setMax(100)
    img.src = imageSrc
  }, [imageSrc])

  useEffect(() => {
    if (numericValue > max) {
      onChange(String(max))
    }
  }, [max, numericValue, onChange])

  const clampedValue = Math.min(numericValue, max)

  return (
    <div className="logo-size">
      <label className="logo-size-label" htmlFor={id}>Logo size</label>
      <input
        id={id}
        type="range"
        min="10"
        max={max}
        value={clampedValue}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  )
}

export default LogoSizeSlider
